<template>
  <div>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="row">
      <div class="col-md-9">
        <label>
          Motivo da alteração
          <span class="m--font-danger">*</span>
        </label>
        <div class="input-group">
          <input
            type="text"
            ref="change_reason"
            class="form-control"
            maxlength="255"
            v-model="change_reason"
            placeholder="Motivo da alteração"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label>Grupo</label>
        <div class="input-group">
          <SelectCustomerContractReasonGroup
            @change="onChangeReasonGroup($event)"
            :selected="change_reason_group_id"
            :first="'Selecione um grupo'"
            ref="change_reason_group_id"
          ></SelectCustomerContractReasonGroup>
        </div>
      </div>
    </div>
    <hr />
    <div
      class="m-accordion m-accordion--default"
      id="m_accordion"
      role="tablist"
    >
      <div
        class="m-accordion__item"
        v-for="detail in filteredData"
        :key="detail.type_id"
      >
        <div
          class="m-accordion__item-head collapsed"
          role="tab"
          :id="`m_accordion_${detail.key}_head`"
          data-toggle="collapse"
          :href="`#m_accordion_${detail.key}_body`"
          aria-expanded="false"
        >
          <span class="m-accordion__item-icon">
            <i :class="detail.icon"></i>
          </span>
          <span class="m-accordion__item-title">
            {{ detail.title }}
            <i
              class="fas fa-info-circle info-icon"
              v-b-tooltip
              :title="detail.tooltip"
            ></i>
            <i
              v-show="!detail.pattern.ranges && detail.details[0].price > 0 && detail.type_id != 3"
              class="far fa-check m--font-success ml-2"
            ></i>
            <i
              v-show="detail.pattern.ranges && detail.details[0].amount > 0 && detail.type_id != 3"
              class="far fa-check m--font-success ml-2"
            ></i>
            <i
              v-show="detail.type_id == 3 && hasNumbersConfigured(detail)"
              class="far fa-check m--font-success ml-2"
            ></i>
            <i
              v-show="
                detail.key == 'enterpriseSession' &&
                detail.datas.enterprise_use_facebook_prices &&
                !detail.details[0].price &&
                !detail.details[0].amount &&
                detail.datas.enterprise_session_unified &&
                detail.pattern.ranges &&
                detail.details[0].amount == 0 &&
                detail.details[0].price == 0
              "
              class="far fa-check m--font-success ml-2"
            ></i>
          </span>
          <span class="m-accordion__item-mode"></span>
        </div>
        <div
          class="m-accordion__item-body collapse"
          :id="`m_accordion_${detail.key}_body`"
          role="tabpanel"
          :aria-labelledby="`m_accordion_${detail.key}_head`"
          data-parent="#m_accordion"
          style
        >
          <div class="m-accordion__item-content">
            <div
              v-if="
                detail.datas &&
                detail.datas.billing_type == 4 &&
                detail.type_id == 3
              "
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-check mb-2">
                    <input
                      id="ignore_number_maintenance"
                      class="form-check-input"
                      type="checkbox"
                      v-model="data.ignore_number_maintenance"
                      :true-value="1"
                      :false-value="0"
                      :disabled="!isLord"
                    />
                    <label
                      class="form-check-label"
                      for="ignore_number_maintenance"
                      v-b-tooltip
                      :title="
                        isLord
                          ? ''
                          : 'Apenas usuários autorizados podem alterar esta opção.'
                      "
                    >
                      Desconsiderar manutenção de número (o valor cobrado
                      respeitará o valor configurado nas faixas)
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        v-b-tooltip.html
                        title="Manutenção de números cobrada após a data definida. (01/08/2025)"
                      >
                        Valor manutenção número&nbsp;
                        <i class="fas fa-info-circle info-icon"></i>
                      </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="numberMaintenanceValue"
                      :readonly="true"
                      :disabled="data.ignore_number_maintenance == 1"
                    ></money>
                  </div>
                </div>
              </div>
              <hr />
            </div>

            <div
              v-if="
                detail.pattern.billing_type && detail.key != 'enterpriseSession'
              "
            >
              Escolha a faixa:
              <div
                class="btn-group btn-sm btn-group-toggle"
                data-toggle="buttons"
              >
                <label
                  class="btn btn-sm btn-secondary"
                  @click="detail.datas.billing_type = 4"
                  :class="{
                    active: detail.datas.billing_type == 4,
                  }"
                  v-b-tooltip.html
                  :title="getRangeTooltip(4)"
                >
                  <input
                    type="radio"
                    name="billing_type"
                    v-model="detail.datas.billing_type"
                    value="4"
                  />
                  Faixa modular mista
                </label>
              </div>
              <hr v-if="detail.datas.billing_type == 4" />
            </div>

            <div
              v-if="
                detail.pattern.charge_use_only && detail.datas.billing_type == 4
              "
            >
              Realizar cobranças por:
              <i
                class="fas fa-info-circle info-icon"
                v-b-tooltip.html
                :title="'TODOS - Cobra qualquer usuário cadastrado e ativo, independente do uso e gestor que enviou ' + (detail.datas.manager_message_threshold != null && detail.datas.manager_message_threshold !== '' ? detail.datas.manager_message_threshold : 100) + ' ou mais mensagens.<br><br>APENAS POR USO - Cobra apenas usuário operadores que enviaram pelo menos 1 mensagem em um atendimento e gestor que enviou ' + (detail.datas.manager_message_threshold != null && detail.datas.manager_message_threshold !== '' ? detail.datas.manager_message_threshold : 100) + ' ou mais mensagens.'"
              ></i>
              <div
                class="btn-group btn-sm btn-group-toggle"
                data-toggle="buttons"
              >
                <label
                  class="btn btn-sm btn-secondary"
                  @click="detail.datas.charge_use_only = 0"
                  :class="{
                    active:
                      detail.datas.charge_use_only == 0 ||
                      !detail.datas.charge_use_only,
                  }"
                >
                  <input
                    type="radio"
                    name="charge_use_only"
                    v-model="detail.datas.charge_use_only"
                    value="0"
                  />
                  Todas
                </label>
                <label
                  class="btn btn-sm btn-secondary"
                  @click="detail.datas.charge_use_only = 1"
                  :class="{
                    active: detail.datas.charge_use_only == 1,
                  }"
                >
                  <input
                    type="radio"
                    name="charge_use_only"
                    v-model="detail.datas.charge_use_only"
                    value="1"
                  />
                  Apenas por uso
                </label>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label>
                    Mínimo de mensagens do gestor para cobrança
                    <i
                      class="fas fa-info-circle info-icon"
                      v-b-tooltip.html
                      title="Quantidade mínima de mensagens que o gestor precisa ter enviado para ser cobrado.<br>Se vazio, utiliza o padrão de 100 mensagens.<br>Se 0, todos os gestores serão cobrados."
                    ></i>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    step="1"
                    v-model.number="detail.datas.manager_message_threshold"
                    placeholder="100"
                    @keypress="$event.key === '-' || $event.key === '.' || $event.key === ',' || $event.key === 'e' ? $event.preventDefault() : null"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label>
                    Cobrança de licença
                    <i
                      class="fas fa-info-circle info-icon"
                      v-b-tooltip.html
                      title="<b>Proporcional</b> - Cobra proporcionalmente considerando a data de criação e inativação do usuário.<br><b>Valor cheio</b> - Cobra o valor cheio independente da data de criação ou inativação do usuário."
                    ></i>
                  </label>
                  <div
                    class="btn-group btn-sm btn-group-toggle"
                    data-toggle="buttons"
                  >
                    <label
                      class="btn btn-sm btn-secondary"
                      @click="detail.datas.charge_full_license_price = 0"
                      :class="{
                        active:
                          detail.datas.charge_full_license_price == 0 ||
                          !detail.datas.charge_full_license_price,
                      }"
                    >
                      <input
                        type="radio"
                        name="charge_full_license_price"
                        v-model="detail.datas.charge_full_license_price"
                        value="0"
                      />
                      Proporcional
                    </label>
                    <label
                      class="btn btn-sm btn-secondary"
                      @click="detail.datas.charge_full_license_price = 1"
                      :class="{ active: detail.datas.charge_full_license_price == 1 }"
                    >
                      <input
                        type="radio"
                        name="charge_full_license_price"
                        v-model="detail.datas.charge_full_license_price"
                        value="1"
                      />
                      Valor cheio
                    </label>
                  </div>
                </div>
              </div>
              <hr />
            </div>

            <div class="row" v-if="detail.key == 'enterpriseSession' && false">
              <div class="col-md-6">
                <div class="form-check form-check-inline">
                  <input
                    id="use_facebook_bonus"
                    class="form-check-input"
                    type="checkbox"
                    v-model="detail.datas.enterprise_use_facebook_bonus"
                    value="0"
                  />
                  <label class="form-check-label" for="use_facebook_bonus"
                    >Aplicar bônus cedido pelo facebook</label
                  >
                </div>
              </div>
            </div>

            <div class="row" v-if="detail.key == 'enterpriseSession' && false">
              <div class="col-md-6">
                <div class="form-check form-check-inline">
                  <input
                    id="use_facebook_prices"
                    class="form-check-input"
                    type="checkbox"
                    v-model="detail.datas.enterprise_use_facebook_prices"
                    value="0"
                  />
                  <label class="form-check-label" for="use_facebook_prices"
                    >Usar valores do facebook (convertido no valor do dólar
                    atual)</label
                  >
                </div>
              </div>
            </div>

            <div class="row" v-if="detail.key == 'enterpriseSession'">
              <div class="col-md-6">
                <div class="form-check form-check-inline">
                  <input
                    id="use_unified_billing"
                    class="form-check-input"
                    type="checkbox"
                    v-model="detail.datas.enterprise_use_unified_billing"
                    value="0"
                    @change="
                      (event) =>
                        onEnterpriseUnifiedCheckboxChange(detail, event)
                    "
                  />
                  <label class="form-check-label" for="use_unified_billing"
                    >Usar cobrança unificada</label
                  >
                </div>
              </div>
            </div>

            <div
              v-if="
                detail.datas.enterprise_use_unified_billing == true &&
                detail.key == 'enterpriseSession'
              "
              style="margin-top: 8px"
            >
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_unified_billing)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      type="number"
                      class="form-control m-input"
                      v-model="detail.datas.quantity_unified_billing"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Valor </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_unified"
                      :readonly="detail.datas.enterprise_use_facebook_prices"
                    ></money>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <hr v-if="detail.datas && detail.key == 'enterpriseSession'" />
            <!-- Valor Ativo oculto: não é utilizado na cobrança de sessão -->
            <div v-if="detail.datas && detail.key == 'enterpriseSession' && false">
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_enterprise_session_active)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      type="number"
                      class="form-control m-input"
                      v-model="detail.datas.quantity_enterprise_session_active"
                      :readonly="
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Valor Ativo </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_active"
                      :readonly="
                        detail.datas.enterprise_use_facebook_prices ||
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    ></money>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div v-if="detail.datas && detail.key == 'enterpriseSession'">
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_enterprise_session_authentication)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      id="txtSessionAuthenticationQuantity"
                      type="number"
                      class="form-control m-input"
                      v-model="
                        detail.datas.quantity_enterprise_session_authentication
                      "
                      :readonly="
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Autenticação </span>
                    </div>
                    <money
                      id="txtSessionAuthenticationValue"
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_authentication"
                      :readonly="
                        detail.datas.enterprise_use_facebook_prices ||
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    ></money>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div v-if="detail.datas && detail.key == 'enterpriseSession'">
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_enterprise_session_utility)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      id="txtSessionUtilityQuantity"
                      type="number"
                      class="form-control m-input"
                      v-model="detail.datas.quantity_enterprise_session_utility"
                      :readonly="
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Utilitário </span>
                    </div>
                    <money
                      id="txtSessionUtilityValue"
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_utility"
                      :readonly="
                        detail.datas.enterprise_use_facebook_prices ||
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    ></money>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div v-if="detail.datas && detail.key == 'enterpriseSession'">
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_enterprise_session_marketing)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      id="txtSessionMarketingQuantity"
                      type="number"
                      class="form-control m-input"
                      v-model="
                        detail.datas.quantity_enterprise_session_marketing
                      "
                      :readonly="
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Marketing </span>
                    </div>
                    <money
                      id="txtSessionMarketingValue"
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_marketing"
                      :readonly="
                        detail.datas.enterprise_use_facebook_prices ||
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    ></money>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <!-- Serviço é cobrado à parte do unificado: o valor fica editável com a cobrança unificada -->
            <div v-if="detail.datas && detail.key == 'enterpriseSession'">
              <small
                v-if="detail.datas.enterprise_use_unified_billing == true"
                id="infoSessionServiceUnified"
                class="form-text text-muted mb-1"
              >
                Com a cobrança unificada, a Sessão Serviço é cobrada à parte
              </small>
              <div class="row">
                <div class="col-md-6" v-if="shouldShowQuantityField(detail.datas.quantity_enterprise_session_services)">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Quantidade </span>
                    </div>
                    <input
                      id="txtSessionServiceQuantity"
                      type="number"
                      class="form-control m-input"
                      v-model="detail.datas.quantity_enterprise_session_services"
                      :readonly="
                        detail.datas.enterprise_use_unified_billing == true
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Serviço </span>
                    </div>
                    <money
                      id="txtSessionServiceValue"
                      v-bind="moneyService"
                      class="form-control m-input"
                      v-model="detail.datas.enterprise_session_services"
                      :readonly="detail.datas.enterprise_use_facebook_prices"
                    ></money>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                detail.datas &&
                detail.datas.billing_type == 4 &&
                detail.type_id != 32 &&
                detail.type_id != 37
              "
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> Valor extra </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.extra"
                    ></money>
                  </div>
                </div>
              </div>
              <hr />
            </div>

            <div
              v-if="
                detail.pattern.fixed &&
                detail.datas.billing_type == 4 &&
                detail.key != 'enterpriseSession'
              "
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        v-b-tooltip.html
                        title="Valor fixo que será acrescentado ao resultado do cálculo <b>deste item</b>. <br>Se o resultado deste item é R$100,00 e o valor fixo é R$50,00, o valor final deste item será R$150,00."
                        >Valor fixo&nbsp;
                        <i class="fas fa-info-circle info-icon"></i>
                      </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.fixed"
                    ></money>
                  </div>
                </div>
              </div>
              <hr />
            </div>
            <div
              v-if="
                detail.pattern.minimal &&
                detail.datas.billing_type == 4 &&
                detail.key != 'enterpriseSession'
              "
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        v-b-tooltip.html
                        title="Valor mínimo que pode ser cobrado por <b>este item</b>.<br>Ex: Valor mínimo = R$100,00<br>Valor calculado pelo consumo = R$53,00. <br>O valor adicionado na fatura será de R$100,00."
                      >
                        Valor mínimo&nbsp;
                        <i class="fas fa-info-circle info-icon"></i>
                      </span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.datas.minimal"
                    ></money>
                  </div>
                </div>
              </div>
              <hr />
            </div>
            <div v-if="detail.key == 'contact'">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        Licenças inclusas&nbsp;
                      </span>
                    </div>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control m-input"
                      v-model="detail.datas.licenses_included"
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        Receptivos por excedentes&nbsp;
                      </span>
                    </div>
                    <input
                      type="number"
                      step="1"
                      min="0"
                      max="999999999"
                      class="form-control m-input"
                      v-model="detail.datas.receptive_excess"
                    />
                  </div>
                </div>
              </div>
              <hr />
            </div>

            <div
              v-if="
                detail.pattern.ranges &&
                detail.datas.billing_type == 4 &&
                detail.key != 'enterpriseSession'
              "
            >
              <div v-for="price in detail.details" :key="price.id">
                <div class="row">
                  <div class="col-md-5">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">Até</span>
                      </div>
                      <input
                        type="number"
                        step="1"
                        min="0"
                        max="999999999"
                        class="form-control"
                        v-model="price.amount"
                        placeholder="0"
                      />
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">Valor</span>
                      </div>
                      <money
                        v-bind="money"
                        class="form-control m-input"
                        v-model="price.price"
                      ></money>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div v-if="!detail.pattern.ranges">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">Valor Mensal</span>
                </div>
                <money
                  v-bind="money"
                  class="form-control m-input"
                  v-model="detail.details[0].price"
                ></money>
              </div>
            </div>

            <div
              v-if="
                detail.pattern.ranges &&
                detail.datas.billing_type == 4 &&
                detail.key != 'enterpriseSession'
              "
            >
              <button
                type="button"
                class="btn btn-sm btn-metal m-btn m-btn--custom float-right mb-3 mt-3"
                @click="detail.details.push({})"
              >
                <i class="fas fa-plus-circle"></i> Adicionar valor
              </button>
            </div>
            <div
              class="col-md-6"
              v-if="detail.key == 'contact' && detail.datas.billing_type == 4"
            >
              <div class="form-group mb-0">
                <label>
                  Cobrança contato receptivo:
                  <i
                    class="fas fa-info-circle info-icon"
                    v-b-tooltip.html
                    title="<b>Contato único</b> - Cobra apenas atendimentos de contatos diferentes, se um mesmo número de Whatsapp entrar em contato múltiplas vezes <b>no mês</b> será contabilizado apenas 1 contato.<br>
                                <b>Contato total</b> - Cobra <b>todos</b> os contatos receptivos, cada novo atendimento será cobrado.
                                "
                  ></i>
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="contact_recep_unique"
                  class="form-check-input"
                  type="radio"
                  v-model="detail.datas.contact_recep_total"
                  value="0"
                />
                <label class="form-check-label" for="contact_recep_unique"
                  >Único</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="contact_recep_total"
                  class="form-check-input"
                  type="radio"
                  v-model="detail.datas.contact_recep_total"
                  value="1"
                />
                <label class="form-check-label" for="contact_recep_total"
                  >Total</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="m-accordion__item"
        key="additional_itens"
        v-if="isVisibleAdditional"
      >
        <div
          class="m-accordion__item-head collapsed"
          role="tab"
          :id="`m_accordion_additional_head`"
          data-toggle="collapse"
          :href="`#m_accordion_additional_body`"
          aria-expanded="false"
        >
          <span class="m-accordion__item-icon">
            <i class="fal fa-list"></i
          ></span>
          <span class="m-accordion__item-title">
             Serviços Adicionais
               <i
                class="fas fa-info-circle info-icon"
                v-b-tooltip.html
                title="Um valor fixo cobrado todo faturamento."
              ></i>
            <i
              v-show="isAdditionalConfigured()"
              class="far fa-check m--font-success ml-2"
            ></i>
          </span>
          <span class="m-accordion__item-mode"></span>
        </div>
        <div
          class="m-accordion__item-body collapse"
          :id="`m_accordion_additional_body`"
          role="tabpanel"
          :aria-labelledby="`m_accordion_additional_head`"
          data-parent="#m_accordion"
          style
        >
          <div class="m-accordion__item-content">
            <div
              v-for="detail in additionalData"
              class="input-group"
              :key="detail.type_id"
            >
              <div class="input-group-prepend mb-2">
                <span class="input-group-text"> {{ detail.title }}</span>
              </div>
              <money
                v-bind="money"
                class="form-control m-input"
                v-model="detail.details[0].price"
              ></money>
            </div>
          </div>
        </div>
      </div>
      <contract-informative-services :services="informativeData" />
      <hr class="row mt-5 mb-3" />
      <div class="row">
        <div class="col-md-12 text-right">
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.change_reason.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!change_reason"
            >
              O campo
              <strong>Motivo da alteração</strong> é obrigatório *
            </a>
          </p>
        </div>
        <div class="col-md-12 text-right">
          <p class="p-0 m-0">
            <a
              href="#"
              @click.prevent="$refs.change_reason_group_id.$el.focus()"
              target="_self"
              class="m--font-danger"
              v-if="!change_reason_group_id"
            >
              O campo
              <strong>Grupo da alteração</strong> é obrigatório *
            </a>
          </p>
        </div>
      </div>
      <div class="row mb-5 mt-5">
        <div class="col-md-12" style="text-align: right">
          <button
            @click.prevent="saveForm()"
            class="btn"
            :class="{ 'btn-metal': !formIsValid, 'btn-success': formIsValid }"
            :disabled="!formIsValid"
          >
            <i class="fas fa-save"></i>
            Salvar Contrato
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { tooltipMixin } from '@/mixins/tooltipMixin.js';
import { lordRoleMixin } from '@/mixins/lordRoleMixin.js';
import SelectCustomerContractReasonGroup from '@/components/forms/SelectCustomerContractReasonGroup';
import ContractInformativeServices from '@/components/contracts/ContractInformativeServices';

import { Money } from 'v-money';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  props: {
    changeReason: String,
    changeReasonGroup: String,
  },
  mixins: [returnMessageFormMixin, tooltipMixin, lordRoleMixin],
  name: 'ContractServices',
  components: {
    Money,
    SelectCustomerContractReasonGroup,
    ContractInformativeServices,
  },
  data() {
    return {
      isVisibleAdditional: false,
      unifiedBackup: {},
      additionalData: {},
      informativeData: {},
      data: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      moneyService: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 3,
        masked: false,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      change_reason: null,
      change_reason_group_id: null,
    };
  },
  methods: {
    onEnterpriseUnifiedCheckboxChange(detail, event) {
      // ao desmarcar, guarda os valores do unificado para restaurar se marcar de novo
      if (!event.target.checked) {
        this.unifiedBackup[detail.key] = {
          quantity_unified_billing: detail.datas.quantity_unified_billing,
          enterprise_session_unified: detail.datas.enterprise_session_unified,
        };
        detail.datas.quantity_unified_billing = '';
        detail.datas.enterprise_session_unified = '';
        return;
      }
      const backup = this.unifiedBackup[detail.key];
      if (backup) {
        detail.datas.quantity_unified_billing = backup.quantity_unified_billing;
        detail.datas.enterprise_session_unified = backup.enterprise_session_unified;
      }
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      this.syncNumberMaintenanceData();

      const url = `${baseApiUrl}/v1/customer/contract/service/save`;
      const { ignore_number_maintenance, ...serviceData } = this.data;
      const combinedData = {
        ...serviceData,
        ...this.additionalData,
        ...this.informativeData,
      };
      axios
        .post(url, {
          contractId: this.contractId,
          changeReason: this.change_reason,
          changeReasonGroup: this.change_reason_group_id,
          ignore_number_maintenance: ignore_number_maintenance,
          services: combinedData,
        })
        .then((res) => {
          this.logMessageForm(res);
          this.$emit('changedReason', this.change_reason);
          this.$emit('changedReasonGroup', this.change_reason_group_id);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja excluir o contato selecionado?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Confirmar exclusão',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O contato não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'error',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/contract/delete/${id}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => this.logMessageFailed(error.response));
    },
    getDatas() {
      let url = `${baseApiUrl}/v1/customer/contract/service/data/${this.contractId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });

      url = `${baseApiUrl}/v1/customer/contract/service/additional/data/${this.contractId}`;
      axios(url).then((res) => {
        this.additionalData = res.data;
        if (Object.keys(this.additionalData).length > 0) {
          this.isVisibleAdditional = true;
        }
      });

      url = `${baseApiUrl}/v1/customer/contract/service/informative/data/${this.contractId}`;
      axios(url).then((res) => {
        this.informativeData = res.data;
      });
    },
    callData() {
      this.getDatas();
    },

    onChangeReasonGroup(group) {
      this.change_reason_group_id = group;
    },
    isAdditionalConfigured() {
      const additional = Object.values(this.additionalData);
      const configured = additional.some((detail) => {
        return (
          detail.details[0].price !== null &&
          detail.details[0].price !== undefined &&
          detail.details[0].price !== '' &&
          detail.details[0].price > 0
        );
      });

      return !configured ? false : true;
    },
    shouldShowQuantityField(value) {
      return process.env.VUE_APP_ENABLE_SESSION_QUANTITY === 'true' || 
             (value !== null && value !== undefined && value !== '' && value !== 0);
    },
    hasNumberMaintenanceConfigured(key) {
      if (!this.data || !this.data.numberMaintenance) {
        return false;
      }
      
      const numberMaintenance = this.data.numberMaintenance;
      return numberMaintenance.details && 
             numberMaintenance.details[0] && 
             numberMaintenance.details[0].price && 
             numberMaintenance.details[0].price > 0;
    },
    hasNumbersConfigured(detail) {
      const hasRegularConfig = (!detail.pattern.ranges && detail.details[0].price > 0) ||
                              (detail.pattern.ranges && detail.details[0].amount > 0);
      
      const hasMaintenanceConfig = this.hasNumberMaintenanceConfigured(detail.key);
      
      return hasRegularConfig || hasMaintenanceConfig;
    },
    syncNumberMaintenanceData() {
      const currentValue = this.numberMaintenanceValue || 0;
      
      this.ensureNumberMaintenanceStructure(currentValue);
    },
    ensureNumberMaintenanceStructure(value) {
      const amountValue = value > 0 ? 1 : null;
      
      const numbersDetail = Object.values(this.data).find(detail => detail.type_id == 3);
      const billingType = numbersDetail && numbersDetail.datas ? numbersDetail.datas.billing_type : 4;
      
      if (!this.data.numberMaintenance) {
        this.data.numberMaintenance = {
          details: [{ price: value, amount: amountValue }],
          datas: { number_maintenance: value, billing_type: billingType }
        };
        return;
      }
      
      if (!this.data.numberMaintenance.details) {
        this.data.numberMaintenance.details = [{ price: value, amount: amountValue }];
      } else if (!this.data.numberMaintenance.details[0]) {
        this.data.numberMaintenance.details[0] = { price: value, amount: amountValue };
      } else {
        this.data.numberMaintenance.details[0].price = value;
        this.data.numberMaintenance.details[0].amount = amountValue;
      }
      
      if (!this.data.numberMaintenance.datas) {
        this.data.numberMaintenance.datas = { billing_type: billingType };
      }
      this.data.numberMaintenance.datas.number_maintenance = value;
      this.data.numberMaintenance.datas.billing_type = billingType;
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    formIsValid() {
      if (this.change_reason && this.change_reason_group_id) {
        return true;
      }
      return false;
    },
    filteredData() {
      if (!this.data || typeof this.data !== 'object') {
        return {};
      }
      
      const filtered = {};
      Object.keys(this.data).forEach(key => {
        const value = this.data[key];
        const isService = value && typeof value === 'object' && value.pattern;
        if (key !== 'numberMaintenance' && isService) {
          filtered[key] = value;
        }
      });
      
      return filtered;
    },
    numberMaintenanceValue: {
      get() {
        if (this.data && this.data.numberMaintenance && 
            this.data.numberMaintenance.details && 
            this.data.numberMaintenance.details[0] && 
            (this.data.numberMaintenance.details[0].price !== null && this.data.numberMaintenance.details[0].price !== undefined)) {
          return this.data.numberMaintenance.details[0].price;
        }
        
        const numbersDetail = Object.values(this.data).find(detail => detail.type_id == 3);
        if (numbersDetail && numbersDetail.datas && 
            (numbersDetail.datas.number_maintenance !== null && numbersDetail.datas.number_maintenance !== undefined)) {
          return numbersDetail.datas.number_maintenance;
        }
        
        return 0;
      },
      set(value) {
        this.ensureNumberMaintenanceStructure(value || 0);
      }
    },
  },
  watch: {
    contractId() {
      if (this.contractId !== 'add') {
        this.callData();
      }
    },
    changeReason() {
      this.change_reason = this.changeReason;
    },
    changeReasonGroup() {
      this.change_reason_group_id = this.changeReasonGroup;
    },
  },
  beforeMount() {
    if (this.contractId !== 'add') {
      this.callData();
    }
  },
};
</script>
